import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { TableContextProvider, TableContextProviderProps } from './providers/TableContextProvider';
import Table, { TableProps } from './Table';

export type ContextedTableProps<R extends GridValidRowModel = any> = TableProps<R> &
  Omit<TableContextProviderProps, 'children'>;

export function ContextedTable<R extends GridValidRowModel = any>({
  isMultiselect,
  onClickMoreIcon,
  onChangeSelectionModel,
  customSelectionModel,
  keepPagination,
  ...tableProps
}: ContextedTableProps<R>) {
  return (
    <TableContextProvider
      customSelectionModel={customSelectionModel}
      isMultiselect={isMultiselect}
      keepPagination={keepPagination}
      onChangeSelectionModel={onChangeSelectionModel}
      onClickMoreIcon={onClickMoreIcon}
    >
      <Table<R> {...tableProps} />
    </TableContextProvider>
  );
}
